/**
 * 拠点の各建築タイプの capacityDescription (例 "定員4名・ダブルベッド2台") から定員人数を
 * 抽出し、 重複除去・昇順で「2名」「4名」「6名」形式の配列を返す。
 *
 * 拠点リスト (sidebar) では複数建築タイプの定員を "2名, 4名, 6名" と列挙する
 * (DXPJ-62 デザインレビュー: ベッド数は出さず最大収容人数のレンジを並べる)。
 */
export function buildCapacityLabels(
  accommodations: ReadonlyArray<{
    architectureType: { content: { capacityDescription: string } } | null;
  }>,
): string[] {
  const capacities = new Set<number>();
  for (const a of accommodations) {
    const n = extractCapacity(a.architectureType?.content.capacityDescription);
    if (n !== null) capacities.add(n);
  }
  return [...capacities].sort((a, b) => a - b).map((n) => `${n}名`);
}

/**
 * "定員4名・ダブルベッド2台" → 4。 "定員" 前置きを優先し、 無ければ最初の "N名" を使う
 * (例 "4名(大人2名)" → 4)。 数値が見つからなければ null。
 */
function extractCapacity(
  description: string | null | undefined,
): number | null {
  if (!description) return null;
  const match =
    description.match(/定員\s*(\d+)\s*名/) ?? description.match(/(\d+)\s*名/);
  return match?.[1] ? Number(match[1]) : null;
}
